import React, { Component } from "react";
import  Auth from "@aws-amplify/auth";
import { Provider } from "./src/libs/AuthContext"
import PublicationLoader from "./src/libs/PublicationLoader";
import './src/semantic/dist/semantic.min.css';
import './src/semantic/dist/semantic.css';

class AuthProvider extends Component {
  constructor() {
    super()
    this.state = {
      isAuthenticated: false,
      pubLoader: new PublicationLoader({})
    }
    this.userHasAuthenticated = this.userHasAuthenticated.bind(this)
    this.updatePubLoader = this.updatePubLoader.bind(this)
  }

  async componentDidMount() {
    try {
      if (await Auth.currentSession()) {
        this.userHasAuthenticated(true)
      }
    } catch(e) {
        this.userHasAuthenticated(false)
        console.log(e);
    }
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  updatePubLoader = (pubLoader) => {
     this.setState({ pubLoader: pubLoader})
   }

  render() {
    return (
      <Provider value={{
        isAuthenticated: this.state.isAuthenticated,
        userHasAuthenticated: this.userHasAuthenticated,
        pubLoader: this.state.pubLoader,
        updatePubLoader: this.updatePubLoader
      }}>
        {this.props.children}
      </Provider>
    )
  }
}
export const wrapRootElement = ({ element }) => <AuthProvider>{element}</AuthProvider>;
